import { render } from "./SelectExam.vue?vue&type=template&id=1dbe1d46"
import script from "./SelectExam.vue?vue&type=script&lang=js"
export * from "./SelectExam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__